import Marquee from "react-fast-marquee";
import { useLanguage } from "@/context/LanguageContext";
import SectionLabel from "@/components/SectionLabel";
import {
  OpenAILogo,
  GoogleLogo,
  NotionLogo,
  SlackLogo,
  HubSpotLogo,
  ChromeLogo,
  WhatsAppLogo,
  TelegramLogo,
} from "@/components/BrandLogos";

const TOOLS = [
  { name: "Gmail", Logo: GoogleLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Slack", Logo: SlackLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "HubSpot", Logo: HubSpotLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Notion", Logo: NotionLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Google Drive", Logo: GoogleLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Outlook", Logo: ChromeLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Salesforce", Logo: HubSpotLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Telegram", Logo: TelegramLogo, bg: "#229ED9" },
  { name: "WhatsApp", Logo: WhatsAppLogo, bg: "#25D366" },
  { name: "Teams", Logo: SlackLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "Chrome", Logo: ChromeLogo, bg: "#FFFFFF", border: "#ECE8DD" },
  { name: "OpenAI", Logo: OpenAILogo, bg: "#FFFFFF", border: "#ECE8DD" },
];

function LogoChip({ tool }) {
  return (
    <div className="mx-2 flex items-center gap-2.5 pl-2 pr-4 py-2.5 rounded-full bg-white border border-[#F0EBE0] shadow-[0_4px_12px_-6px_rgba(26,24,20,0.08)]">
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
        style={{ background: tool.bg, border: tool.border ? `1px solid ${tool.border}` : "none" }}
      >
        <tool.Logo size={16} />
      </div>
      <span className="font-display font-bold text-[14px] text-[#1A1814] tracking-tight whitespace-nowrap">
        {tool.name}
      </span>
    </div>
  );
}

export default function Integrations() {
  const { t } = useLanguage();
  return (
    <section
      id="integrations"
      data-testid="integrations-section"
      className="relative bg-[#FAFAF7] paper-grain border-t border-[#F0EBE0] overflow-hidden"
    >
      <div className="container-iko relative py-20 lg:py-24">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="flex justify-center">
            <SectionLabel>{t("integrations.eyebrow")}</SectionLabel>
          </div>
          <h2 className="font-display font-semibold text-3xl lg:text-5xl leading-[1.05] tracking-[-0.034em] text-balance text-[#1A1814] mb-4">
            {t("integrations.title")}
          </h2>
          <p className="text-base lg:text-lg text-[#6B6862] leading-relaxed max-w-xl mx-auto">
            {t("integrations.subtitle")}
          </p>
        </div>

        <div className="space-y-3 py-2">
          <Marquee speed={35} gradient gradientColor="#FAFAF7" gradientWidth={140}>
            {TOOLS.map((tool, i) => (
              <LogoChip key={`a-${i}`} tool={tool} />
            ))}
          </Marquee>
          <Marquee speed={28} direction="right" gradient gradientColor="#FAFAF7" gradientWidth={140}>
            {TOOLS.slice().reverse().map((tool, i) => (
              <LogoChip key={`b-${i}`} tool={tool} />
            ))}
          </Marquee>
        </div>

        <div className="mt-10 text-center">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#6B6862]">
            {t("integrations.more")}
          </span>
        </div>
      </div>
    </section>
  );
}
